const config = {
  API: {
    BASE_URL: 'https://api.art77.estacionometros-meoqui.com/api/v1'
  },
  ASSETS: {
    BASE_URL: 'https://api.art77.estacionometros-meoqui.com'
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js